import { OrganizationType } from "../types";
import { ENTITY_TYPE } from "../types/marker-types";

export const getEntityTypeByOrganizationType = (type: OrganizationType) => {
    return type === OrganizationType.SPO ? ENTITY_TYPE.SPO : ENTITY_TYPE.UNIVERSITY;
};

export const isOrganizationType = (type: ENTITY_TYPE | null) => {
    return type === ENTITY_TYPE.SPO || type === ENTITY_TYPE.UNIVERSITY;
};